export default __webpack_public_path__ + "static/media/bird.d7823bc5.gif";